const dateOptions = {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
};
const formatter = new Intl.DateTimeFormat('en-US', dateOptions);

document.querySelectorAll('[data-date]').forEach(el => {
   
    const date = new Date(el.getAttribute('data-date'));
    let formattedDate = formatter.format(date);

    el.querySelector('span').textContent = formattedDate;

});

// 1. Select the element
const navEl = document.querySelector('.section-header');

const resizeObserver = new ResizeObserver(entries => {
  for (let entry of entries) {
    const height = entry.contentRect.height; // Or use entry.target.offsetHeight
    document.documentElement.style.setProperty('--dynamic-height', `${height}px`);
  }
});

resizeObserver.observe(navEl);


function showOverlay(el) {

    const elWrapper = document.querySelector(`#${el.id}-wrapper`);
    if (el) {
        el.classList.add('active');
        elWrapper.classList.add('active');
        document.body.classList.add('no-scroll');
    }
}
const showEntranceOverlay = !sessionStorage.getItem('popupShown') && !cookieExists('casita_manga_email_submitted');

function validateEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

function cookieExists(name) {
  return document.cookie.split(';').some((item) => item.trim().startsWith(name + '='));
}


document.addEventListener('DOMContentLoaded', () => {

    const urlParams = new URLSearchParams(window.location.search);
    const segment = urlParams.get('utm_segment');
    const email = urlParams.get('email');
    const showEmailOverlay = segment && email && !cookieExists(`casita_manga_email_overlay_viewed_${segment}`);
    // 1. Check if the user has already seen the popup this session
     if (showEmailOverlay) {
        setTimeout(() => {
            showOverlay(document.querySelector('#email-overlay'));
        }, 2000);   
    }else if (showEntranceOverlay) {
        
       
        // 2. Show the popup (using a hypothetical showPopup function)
        setTimeout(() => {
            showOverlay(document.querySelector('#entrance-overlay'));
        }, 2000);

        // 3. Mark the session so it doesn't show again
        sessionStorage.setItem('popupShown', 'true');
    }



    // add button click functionality to custom positioned graphics on site 

    document.querySelectorAll('.multicolumn-list__item[data-url]').forEach(item => {
        item.addEventListener('click', (e) => {
             if(e.target.getAttribute('data-url')){
           window.open(e.target.getAttribute('data-url'), '_blank');
    }
        });
       
});
});





const entranceOverlay = document.querySelector('#entrance-overlay');
const emailOverlay = document.querySelector('#email-overlay');
const emailPopup = document.querySelector('.shopify-app-block');
    entranceOverlay.appendChild(emailPopup);

    [entranceOverlay, emailOverlay].forEach(el => {

        function closeOverlay(el) {
            el.classList.remove('active');
            document.querySelector(`#${el.id}-wrapper`).classList.remove('active');
            document.body.classList.remove('no-scroll');
        }

        el.querySelector('.close')?.addEventListener('click', (e) => {
                closeOverlay(el);
        });

        el.querySelector('.svg-wrapper svg')?.addEventListener('click', (e) => {
            closeOverlay(el);
            
        });
    });


setTimeout(() => {
        // 1. Create the stylesheet
        const sheet = new CSSStyleSheet();
        sheet.replaceSync('h2 {font-family: "AuthenticSans-Bold", sans-serif !important; font-size:40px !important; line-height:100% !important; margin-bottom:16px !important;text-align:left !important; @media (max-width:990px) {font-size:24px !important;}} p { text-align:left !important;} [class^="_formHeader_"] p { text-align:left !important; font-family: "AuthenticSans", sans-serif !important; font-size:14px !important;} form input, button {font-family: "AuthenticSans", sans-serif !important; border-radius:30px !important;} [class^="_formDisclaimer_"] p { text-align:left !important; font-family: "AuthenticSans", sans-serif !important; color: #868686 !important;}');

        // 2. Attach shadow root to an element
        const host = document.querySelector('#app-embed');
        const shadowRoot = host.shadowRoot || host.attachShadow({ mode: 'open' });

        // 3. Adopt the stylesheet
        shadowRoot.adoptedStyleSheets.push(sheet);


        shadowRoot.querySelector('form').addEventListener('submit', (e) => {
            if(validateEmail(shadowRoot.querySelector('input').value)){
                entranceOverlay.querySelector('.signup-image').classList.add('active');



                // set a cookie that Expires in 400 days
                document.cookie = "casita_manga_email_submitted=true; max-age=34560000; path=/; SameSite=Lax";
            }
        });
        }, 1000);



